/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs */

const en_help_center__refund_policy__entry_price__battle_cancel = /** @type {((inputs: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs) => LocalizedString) & { parts: (inputs: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs) => import('../runtime.js').MessagePart[] }} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs) => LocalizedString} */ (() => {
			return /** @type {LocalizedString} */ (`Battle Cancellation: If BidBattles cancels a battle for any reason, all participants will receive a 100% refund of the entry price, for the unused bids you will receive Bidbattle Loyalty Coins in your account.`)
		}),
		{
			parts: /** @type {(inputs: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs) => import('../runtime.js').MessagePart[]} */ (() => {
				return /** @type {import('../runtime.js').MessagePart[]} */ ([{ type: "markup-start", name: "strong", options: {}, attributes: {} }, { type: "text", value: "Battle Cancellation:" }, { type: "markup-end", name: "strong", options: {}, attributes: {} }, { type: "text", value: " If BidBattles cancels a battle for any reason, all participants will receive a 100% refund of the entry price, for the unused bids you will receive Bidbattle Loyalty Coins in your account." }])
			})
		}
	)
);

/**
* | output |
* | --- |
* | "Battle Cancellation: If BidBattles cancels a battle for any reason, all participants will receive a 100% refund of the entry price, for the unused bids you w..." |
*
* @param {Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__refund_policy__entry_price__battle_cancel = /** @type {((inputs?: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs, options?: { locale?: "en" }) => LocalizedString) & { parts: (inputs?: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[] } & import('../runtime.js').MessageMetadata<Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs, { locale?: "en" }, { strong: { options: {}; attributes: {}; children: true } }>} */ (
	/* @__PURE__ */ Object.assign(
		/** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs, options?: { locale?: "en" }) => LocalizedString} */ ((inputs = {}, options = {}) => {
			const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
			return en_help_center__refund_policy__entry_price__battle_cancel(inputs)
		}),
		{
			parts: /** @type {(inputs?: Help_Center__Refund_Policy__Entry_Price__Battle_CancelInputs, options?: { locale?: "en" }) => import('../runtime.js').MessagePart[]} */ ((inputs = {}, options = {}) => {
				const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
				return typeof en_help_center__refund_policy__entry_price__battle_cancel.parts === "function" ? en_help_center__refund_policy__entry_price__battle_cancel.parts(inputs) : [{ type: "text", value: en_help_center__refund_policy__entry_price__battle_cancel(inputs) }]
			})
		}
	)
);